import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import "../Users/User.css"; // Assuming User.css has necessary styles

const View = () => {
  document.title = "Charger | View";
  
  const [charger, setCharger] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const params = useParams();
  const ChargerID = params.cid;
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/chargers/details/${ChargerID}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res.data && res.data.data) {
        setCharger(res.data.data); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    } finally {
      setLoading(false); // Stop the loader after data fetch
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("charger........", charger);

  return (
    <>
   
        {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) :  (
        <div className="container my-5">
          <div className="card shadow-lg p-4">
            <h1 className="page-title text-center mb-4">Charger Details</h1>
            <div className="profile-header text-center">
              <img
                className="profile-image rounded-circle mb-3"
                src={charger[0]?.charger?.charger_image || image}
                alt="Charger"
              />
              <h5>{charger[0]?.charger?.charger_name}</h5>
            </div>
            
            <div className="profile-info mt-4">
              <h3 className="section-title">Charger Information</h3>
              <div className="row">
                <div className="col-md-6">
                  <p><span className="info-label">Charger Name:</span> &nbsp; <b>{charger[0]?.charger?.charger_name|| "NA"}</b></p>
                  <p><span className="info-label">Address:</span>&nbsp; <b>{charger[0]?.address|| "NA"}</b></p>
                  <p><span className="info-label">Status:</span> &nbsp; <b>{charger[0]?.charger?.status|| "NA"}</b></p>
                  <p><span className="info-label">Latitude:</span>  &nbsp;<b>{charger[0]?.latitude|| "NA"}</b></p>
                  <p><span className="info-label">Longitude:</span>&nbsp; <b>{charger[0]?.longitude|| "NA"}</b></p>
                  <p><span className="info-label">Charger Type:</span>&nbsp; <b>{charger[0]?.charger?.master_charger_type_id[0]?.title || "N/A"}</b></p>
                  <p><span className="info-label">IMEI Number:</span> &nbsp;<b>{charger[0]?.charger?.imei_number|| "NA"}</b></p>
                  <p><span className="info-label">Maximum Current:</span>&nbsp; <b>{charger[0]?.charger?.max_current|| "NA"}</b></p>
                  <p><span className="info-label">Mettalic Property:</span>&nbsp; <b>{charger[0]?.charger?.charger_ion_type}</b></p>
                </div>
                <div className="col-md-6">
                  <p><span className="info-label">Power:</span> &nbsp;<b>{charger[0]?.charger?.select_power_str|| "NA"}</b></p>
                  <p><span className="info-label">Service Provider:</span> &nbsp; <b>{charger[0]?.charger?.service_provider_str|| "NA"}</b></p>
                  <p><span className="info-label">Amenities:</span> &nbsp;<b>{charger[0]?.charger?.select_amenity_str|| "NA"}</b></p>
                  <p><span className="info-label">Supported Vehicles:</span> &nbsp; <b>{charger[0]?.charger?.select_vehicle_str|| "NA"}</b></p>
                  <p><span className="info-label">Booking Amount:</span> &nbsp; <b>{charger[0]?.charger?.booking_amount || "NA"}</b></p>
                  <p><span className="info-label">Tax:</span> &nbsp; <b>{charger[0]?.charger?.tax || "NA"}</b></p>
                  <p><span className="info-label">Per Unit Price with GST:</span> &nbsp; <b>{charger[0]?.charger?.per_unit_price_with_gst || "NA"}</b></p>
                  <p><span className="info-label">Maximum Voltage:</span> &nbsp; <b>{charger[0]?.charger?.max_voltage}</b></p>
                </div>
              </div>
            </div>
            <hr />
            <div className="meter-values mt-4">
              <h3 className="section-title">Meter Values</h3>
              <div className="row">
                <div className="col-md-6">
                  <p><span className="info-label">Last Transaction ID:</span> &nbsp; <b>{charger?.charger?.last_transaction_id || "NA"}</b></p>
                  <p><span className="info-label">Meter Start:</span> &nbsp; <b>{charger?.charger?.meterStart || "NA"}</b></p>
                  <p><span className="info-label">Meter Stop:</span> &nbsp; <b>{charger?.charger?.meterStop || "NA"}</b></p>
                </div>
              </div>
              {charger?.charger?.meterValues?.map((meterValue, idx) => (
                <div key={idx} className="meter-value-group">
                  <h5>Meter Value</h5>
                  {meterValue.sampledValue.map((sample, index) => (
                    <div key={index} className="sampled-value" style={{ marginBottom: "20px" }}>
                      <h5>Meter Value {index + 1}</h5>
                      <p><span className="info-label">Value:</span> &nbsp; <b>{sample.value} {sample.unit}</b></p>
                      <p><span className="info-label">Measurand:</span>  &nbsp;<b>{sample.measurand}</b></p>
                      <p><span className="info-label">Format:</span> &nbsp; <b>{sample.format}</b></p>
                      <p><span className="info-label">Location:</span> &nbsp; <b>{sample.location}</b></p>
                      <p><span className="info-label">Context:</span> &nbsp; <b>{sample.context}</b></p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <h3 className="section-title">Connectors</h3>
{charger[0]?.charger?.connectors?.map((connector, idx) => (
  <div className="meter-values mt-4" key={idx}>
    <div className="row">
      <div className="col-md-6">
        <p>
          <span className="info-label">Connector Name:</span> 
          {/* &nbsp; <b>{connector?.master_connector_id[0]?.title || "NA"}</b> */}
        </p>
        <p>
          <span className="info-label">Connector Status:</span> 
          &nbsp;<b>{connector?.connector_status || "NA"}</b>
        </p>
        {/* Assuming you want to show current, power, and voltage, which are not directly in the connectors array */}
        <p>
          <span className="info-label">Current:</span> &nbsp;
          <b>{connector?.current || "NA"}</b>
        </p>
        <p>
          <span className="info-label">Power:</span> &nbsp;
          <b>{connector?.power || "NA"}</b>
        </p>
        <p>
          <span className="info-label">Voltage:</span> &nbsp;
          <b>{connector?.voltage || "NA"}</b>
        </p>
      </div>
    </div>
  </div>
))}

          </div>
        </div>
      )}
    </>
  );
};

export default View;
